import { render, staticRenderFns } from "./TTCApprovalWrapper.vue?vue&type=template&id=156cdbca&scoped=true&"
import script from "./TTCApprovalWrapper.vue?vue&type=script&lang=js&"
export * from "./TTCApprovalWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TTCApprovalWrapper.vue?vue&type=style&index=0&id=156cdbca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156cdbca",
  null
  
)

export default component.exports